<ng-template
  #subButton
  let-storage>
  <mbs-button
    [isCtrl]="true"
    [size]="size.inherit"
    (click)="handleSubscribe(storage)"
    >subscribe</mbs-button
  >.
</ng-template>

<ng-template #checkPayment>
  Check your
  @if ('Licenses' | can: 'read') {
    <mbs-payment-method-button></mbs-payment-method-button>
  } @else {
    <a [href]="'mailto:' + ubSubscribe.providerContactEmail">Contact the account owner.</a>
  }
</ng-template>
<ng-template
  #alertTemplate
  let-context="context">
  @if (ubSubscribe.deletedTypes.includes(context?.storage?.usageType)) {
    <!-- manually delete -->
    @if (UnifiedBillingAccountType.PaidWithDebtManuallyDeactivated === context?.storage.usageType) {
      <!-- overdue -->
      {{ context?.storage.storageTypeDisplayName }} Storage: The payment for the {{ context?.storage.storageTypeDisplayName }} storage
      service is overdue.
    } @else if (context?.storage.usageTypeDaysCount > 0) {
      {{ context?.storage.storageTypeDisplayName }} Storage: You have deleted your account. The data will be deleted in
      {{ context?.durationToRemoveOrExpire }}. During this time, you can restore your subscription with data saving.
    }
  } @else if (ubSubscribe.overdueTypes.includes(context?.storage.usageType)) {
    {{ context?.storage.storageTypeDisplayName }} Storage: The payment is overdue. The data in the
    {{ context?.storage.storageTypeDisplayName }} Storage will be deleted in {{ context?.durationToRemoveOrExpire }}.
    <ng-container *ngTemplateOutlet="checkPayment"></ng-container>
  } @else if (context?.storage?.usageType === UnifiedBillingAccountType.Trial) {
    {{ context?.storage.storageTypeDisplayName }} Storage: Your trial period expires in {{ context?.durationToRemoveOrExpire }}. Click to
    <ng-container *ngTemplateOutlet="subButton; context: { $implicit: context?.storage }"></ng-container>
  } @else {
    @if (context?.storage.usageType === UnifiedBillingAccountType.TrialReadOnly) {
      {{ context?.storage.storageTypeDisplayName }} Storage: You have reached the limit of your trial storage account. To continue without
      any limits,
      <ng-container *ngTemplateOutlet="subButton; context: { $implicit: context?.storage }"></ng-container>
    }

    @if (context?.storage.usageType === UnifiedBillingAccountType.TrialDeactivated && context?.storage.daysFromStartCurrentState > 0) {
      {{ context?.storage.storageTypeDisplayName }} Storage: The data will be deleted in {{ context?.durationToRemoveOrExpire }}. To
      continue without any limits,
      <ng-container *ngTemplateOutlet="subButton; context: { $implicit: context?.storage }"></ng-container>
    }
  }
</ng-template>
